import { useLayoutEffect, useRef, useState } from 'react';
import HStack from './Layout/HStack';
import AppText from './AppText';
import { Colors } from '../../styles/Colors';
import { GlobalStyleAttributes } from '../../styles/GlobalStyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconSwitcher } from '../Icons8Generator/IconSwitcher';
import { GlobalConsts } from '../../styles/GlobalConsts';

const PickerField = (props) => {
    const { text, items = [], placeholder, onPress } = props;
    const namesRowRef = useRef(null);
    const [hiddenCount, setHiddenCount] = useState(0);
    const visibleCount = items.length - hiddenCount;

    // Names render in a clipped row; count how many fall outside it and cover them with "+N".
    useLayoutEffect(() => {
        const row = namesRowRef.current;
        if (!row) return;
        const countClippedNames = () => {
            const rowRect = row.getBoundingClientRect();
            const isClipped = (name) => name.getBoundingClientRect().right > rowRect.right || name.getBoundingClientRect().left < rowRect.left;
            setHiddenCount([...row.children].filter(isClipped).length);
        };
        countClippedNames();
        const observer = new ResizeObserver(countClippedNames);
        observer.observe(row);
        return () => observer.disconnect();
    }, [items.join()]);

    return (
        <HStack alignItems="center" justifyContent="space-between" width="100%" space="0.5rem" onClick={onPress} style={{ boxSizing: 'border-box', height: '38px', border: `1px solid ${Colors.borderColor}`, borderRadius: '4px', padding: '0 0.5rem', cursor: onPress ? 'pointer' : undefined }}>
            {items.length ? (
                <HStack ref={namesRowRef} flex={1} minWidth={0} style={{ overflow: 'hidden', whiteSpace: 'pre' }}>
                    {items.map((name, index) => (
                        <AppText key={index} fontSize={GlobalStyleAttributes.fonts.standard16} style={{ flexShrink: 0, lineHeight: '22px', visibility: index < visibleCount ? 'visible' : 'hidden' }}>
                            {index ? `, ${name}` : name}
                        </AppText>
                    ))}
                </HStack>
            ) : (
                <AppText numberOfLines={1} ellipsizeMode="tail" fontSize={GlobalStyleAttributes.fonts.standard16} color={text ? Colors.newDesign.mainText : Colors.newDesign.darkGrey} style={{ flex: 1, minWidth: 0, lineHeight: '22px', flexWrap: 'nowrap' }}>{text || placeholder}</AppText>
            )}
            {hiddenCount > 0 && <AppText fontSize={GlobalStyleAttributes.fonts.standard16} color={Colors.newDesign.mainText} style={{ flexShrink: 0 }}>{`+${hiddenCount}`}</AppText>}
            <FontAwesomeIcon icon={IconSwitcher(GlobalConsts.iconPrefix.LIGHT, 'fa-pen')} fontSize={GlobalConsts.iconSize.XS} color={Colors.newDesign.mainText} />
        </HStack>
    );
};

export default PickerField;
